<template>
    <div class="layout-container-box">
        <el-header class="layout-header">
            <Header>
                <template #header-brand>
                    <BreadCrumb :breadList="breadLists" />
                </template>
            </Header>
        </el-header>
        <el-scrollbar class="layout-main-content" id="content_box">
            <div class="pd-20">
                <div class="create-person-container" id="literature">
                    
                    <el-card class="mg-b-16" v-if="activeForm==1">
                        <template #header>
                            <div class="card-header">
                                <span class="card-name">活动基本信息</span>
                            </div>
                        </template>
                        <div class="form-container">
                            <el-form ref="formRef" :model="articeForm" :rules="articeFormRule" label-width="140px"
                                class="user-form-box mg-t-24">

                                <el-form-item label="活动名称：" prop="title">
                                    <el-input style="width: 400px" v-model="articeForm.title" placeholder="请输入"></el-input>
                                </el-form-item>
                                <!-- <el-form-item label="活动状态：" prop="status">
                                    <el-select v-model="articeForm.status" placeholder="选择状态">
                                        <el-option label="待开始" value="1" />
                                        <el-option label="报名中" value="2" />
                                        <el-option label="进行中" value="3" />
                                        <el-option label="已结束" value="4" />
                                    </el-select>
                                </el-form-item> -->
                                <el-form-item label="是否收费：" prop="is_free">
                                    <el-radio-group v-model="articeForm.is_free" class="ml-4" @change="handleCharge(articeForm.is_free)">
                                        <el-radio label="1" size="large">免费</el-radio>
                                        <el-radio label="2" size="large">收费</el-radio>
                                    </el-radio-group>
                                </el-form-item>

                                <el-form-item label="收费金额：" v-if="articeForm.is_free == 2" prop="money">
                                    <el-input style="width: 400px" v-model="articeForm.money" type="number"
                                        oninput="if(value<0)value=0" placeholder="请输入"></el-input>
                                </el-form-item>

                                <el-form-item label="是否需要审核：" prop="is_check">
                                    <el-radio-group v-model="articeForm.is_check" class="ml-4" :disabled="articeForm.is_free==2">
                                        <el-radio label="1" size="large">无需审核</el-radio>
                                        <el-radio label="2" size="large">需要审核</el-radio>
                                    </el-radio-group>
                                </el-form-item>

                                <el-form-item label="活动地点：" prop="activity_mode">
                                    <el-radio-group v-model="articeForm.activity_mode" class="ml-4"  @change="handleLocation(articeForm.activity_mode)">
                                        <el-radio label="1" size="large">线上</el-radio>
                                        <el-radio label="2" size="large">线下</el-radio>
                                    </el-radio-group>
                                    <div class="address_box" v-if="articeForm.activity_mode == 2">
                                        <el-select class="select w-100" placeholder="请选择" :popper-append-to-body="false"
                                            v-model="articeForm.activity_address_city" @change="coutryChange" filterable
                                            remote :reserve-keyword="false" :remote-method="countryRemoteMethod">
                                            <el-option v-for="item in countrys" :key="item.id" :label="item.name"
                                                :value="item.id">
                                                {{ item.name }}
                                            </el-option>
                                        </el-select>
                                        <el-cascader v-model="articeForm.activity_address_city_id" :options="provincesArr"
                                            @change="provinceChange" :props="{
                                                value: 'id',
                                                label: 'name',
                                                children: 'child'
                                            }"></el-cascader>
                                        <el-input style="width: 300px" v-model="articeForm.activity_address"
                                            placeholder="请输入"></el-input>
                                    </div>
                                </el-form-item>

                                <el-form-item label="活动时间：" prop="activity_time">
                                    <el-date-picker v-model="articeForm.activity_time" type="daterange" range-separator="至"
                                        start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD"
                                        format="YYYY-MM-DD" size="default" />

                                </el-form-item>
                                <el-form-item label="头图：" prop="image">
                                    <p>限制大小1M,支持JPG、PNG格式</p>
                                    <el-upload class="avatar-uploader" :class="{
                                        border: !articeForm.image,
                                    }" :show-file-list="false" action="#" :http-request="(file) => {
                                        return uploadImage(file, 'image')
                                    }" accept="image/jpg, image/jpeg, image/png" :before-upload="beforeUpload">
                                        <div class="avatar-img-box" v-if="articeForm.image">
                                            <img :src="articeForm.image" class="avatar" />
                                        </div>
                                        <el-icon v-else class="avatar-uploader-icon">
                                            <plus />
                                        </el-icon>
                                    </el-upload>
                                </el-form-item>

                                <el-form-item label="banner上架：" prop="is_banner">
                                    <el-radio-group v-model="articeForm.is_banner" class="ml-4">
                                        <el-radio label="2" size="large">是</el-radio>
                                        <el-radio label="1" size="large">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>

                                <el-form-item label="报名截止时间：" prop="register_end_time">
                                    <el-date-picker style="width: 400px" type="date" v-model="articeForm.register_end_time"
                                        placeholder="选择日期" value-format="YYYY-MM-DD">
                                    </el-date-picker>
                                </el-form-item>

                                <el-form-item label="活动简介：">
                                    <tinymceEditor :tinymceHtml="articeForm.intro" @saveContent="getContentintro"
                                        v-if="detailFinished" />
                                </el-form-item>
                                <el-form-item label="议程：">
                                    <tinymceEditor :tinymceHtml="articeForm.agenda" @saveContent="getContentagenda"
                                        v-if="detailFinished" />
                                </el-form-item>
                                <el-form-item label="嘉宾：">
                                    <tinymceEditor :tinymceHtml="articeForm.guest" @saveContent="getContentguest"
                                        v-if="detailFinished" />
                                </el-form-item>
                                <el-form-item label="合作单位：">
                                    <tinymceEditor :tinymceHtml="articeForm.cooperation_company" @saveContent="getContentompany"
                                        v-if="detailFinished" />
                                </el-form-item>

                                <el-form-item label="活动资料：">
                                    <el-upload
                                        v-model:file-list="articeForm.activity_data"
                                        class="upload-demo"
                                        action="#"
                                        :http-request="(file) => {
                                            return uploadImage(file, 'file')
                                        }"
                                        
                                        :on-remove="handleRemove"
                                    >
                                        <el-button type="primary">选择文件</el-button>
                                        <template #tip>
                                        <div class="el-upload__tip">
                                            支持pdf、pptx、word格式、图片
                                        </div>
                                        </template>
                                    </el-upload>
                                    <!-- <ul class="file_box">
                                        <li v-for="(file, index) in fileData" :key="index">
                                            {{ file.name }}
                                        </li>
                                    </ul> -->

                                </el-form-item>

                                <el-form-item label="客服信息："></el-form-item>
                                <el-form-item label="客服头像" prop="service_logo">
                                    <el-upload class="avatar-uploader" :class="{
                                        border: !articeForm.service_logo,
                                    }" :show-file-list="false" action="#" :http-request="(file) => {
                                        return uploadImage(file, 'service_logo')
                                    }"
                                        accept="image/jpg, image/jpeg, image/png" :before-upload="beforeUpload">
                                        <div class="avatar-img-box" v-if="articeForm.service_logo">
                                            <img :src="articeForm.service_logo" class="avatar" />
                                        </div>
                                        <el-icon v-else class="avatar-uploader-icon">
                                            <plus />
                                        </el-icon>
                                    </el-upload>
                                </el-form-item>

                                <el-form-item label="客服姓名：" prop="service_name">
                                    <el-input style="width: 400px" v-model="articeForm.service_name"></el-input>
                                </el-form-item>
                                <el-form-item label="客服单位：" prop="service_company">
                                    <el-input style="width: 400px" v-model="articeForm.service_company"></el-input>
                                </el-form-item>
                                <el-form-item label="客服职位：" prop="service_position">
                                    <el-input style="width: 400px" v-model="articeForm.service_position"></el-input>
                                </el-form-item>
                                <el-form-item label="客服电话：" prop="service_phone">
                                    <el-input style="width: 400px" v-model="articeForm.service_phone"></el-input>
                                </el-form-item>


                            </el-form>
                        </div>
                    </el-card>

                    <div v-if="activeForm==2">
                        <createForm :activityId="activityId" :formId = "articeForm.form_id" @handlePrevious="handlePrevious"/>
                    </div>
                    <div class="bottom-submit-box pd-16 mg-t-24" v-if="activeForm==1">
                        <el-row justify="end">
                            <el-col :span="6">
                                <el-button plain @click="cancelSubmit('formRef')">取消</el-button>
                                <el-button plain @click="nextStep">下一步</el-button>
                                <el-button type="primary" @click="submitForm('formRef')">保存</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </el-scrollbar>

    </div>
</template>
  
<script>
import { ref, onMounted, getCurrentInstance, reactive, onBeforeMount, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Ajax, MessageTips } from "../../../utils";
import { Plus, } from "@element-plus/icons-vue";
import MenuTrees from "../../../components/MenuTrees/MenuTrees.vue";
import CheckTag from "../../../components/CheckTag";
import Header from "../../../Layout/components/Header.vue";
import BreadCrumb from "../../../components/BreadCrumb/index.vue";
import tinymceEditor from '@/components/tinymceEditor/index.vue'
import createForm from './createForm.vue'
export default {
    components: {
        Plus,
        MenuTrees,
        CheckTag,
        Header,
        BreadCrumb,
        tinymceEditor,
        createForm
    },
    setup() {
        const router = useRouter();
        const breadLists = ref([
            {
                name: "活动",
                path: {
                    name: "Activity",
                },
            },
            {
                name: "新增活动",
            },
        ]);
        const countrysRef = ref([]);
        const provincesArrRef = ref([]);
        const provinceValRef = ref(null);
        const isLoading = ref(false);
        const route = useRoute();
        const activeForm = ref(1)
        const ifNext = ref(false)
        const activityId = ref('')

        const { proxy } = getCurrentInstance();
        const articeFormRef = ref({
            title: undefined,
            // status: undefined,
            is_free: '1',
            money: undefined,
            is_check: '2',
            activity_mode: '1',
            activity_address_city: undefined,
            activity_address_city_id: undefined,
            activity_address: undefined,
            activity_time: undefined,
            image: undefined,
            is_banner: '1',
            register_end_time: undefined,
            intro: undefined,
            agenda: undefined,
            guest: undefined,
            cooperation_company: undefined,
            activity_data: [],
            service_logo: undefined,
            service_name: undefined,
            service_company: undefined,
            service_position: undefined,
            service_phone: undefined,
        });
        const articeFormRule = {

            title: [
                {
                    required: true,
                    message: "请输入活动名称",
                    trigger: "blur",
                },
            ],
            // status: [
            //     {
            //         required: true,
            //         message: "请选择活动状态",
            //         trigger: "change",
            //     },
            // ],
            is_free: [
                {
                    required: true,
                    message: "请选择是否收费",
                    trigger: "change",
                },
            ],
            money: [
                {
                    required: true,
                    message: "请输入金额",
                    trigger: "blur",
                },
            ],
            is_check: [
                {
                    required: true,
                    message: "请选择是否需要审核",
                    trigger: "change",
                },
            ],
            activity_mode: [
                {
                    required: true,
                    message: "请选择",
                    trigger: "change",
                },
            ],
            activity_time: [
                {
                    required: true,
                    message: "请选择时间",
                    trigger: "blur",
                },
            ],
            image: [
                {
                    required: true,
                    message: "请选择图片",
                    trigger: "blur",
                },
            ],
            service_logo: [
                {
                    required: true,
                    message: "请选择图片",
                    trigger: "blur",
                },
            ],
            service_name: [
                {
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                },
            ],
            service_company: [
                {
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                },
            ],
            service_position: [
                {
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                },
            ],
            service_phone: [
                {
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                },
            ],
        };


        const authorDetail = ref({});
    
        const getContentintro = (val) => {
            articeFormRef.value.intro = val
        }
        const getContentagenda = (val) => {
            articeFormRef.value.agenda = val
        }
        const getContentguest = (val) => {
            articeFormRef.value.guest = val
        }
        const getContentompany = (val) => {
            articeFormRef.value.cooperation_company = val
        }

        const cancelSubmit = (formName) => {
            // proxy.$refs[formName].resetFields();
            router.back();
        };
        const submitForm = (formName) => {
            
            proxy.$refs[formName].validate((valid) => {
                if (valid) {
                    let  articeData =JSON.parse(JSON.stringify(articeFormRef.value));
                        articeData.activity_time = articeData.activity_time.toString()
                        // articeData.activity_data = articeData.activity_data.toString()
                        if(activity_address_city.value!=''){
                            articeData.activity_address_city = activity_address_city.value
                            articeData.activity_address_city_id = [userFormRef.value.country,userFormRef.value.province,userFormRef.value.city]
                        }

                    let url='';
                    if(route.query.id){
                        url=`/admin/activity/update/${route.query.id}`
                    }else{
                        url="/admin/activity/create"
                    }
                    Ajax.POST({
                        url,
                        data: articeData
                        
                    }).then((res) => {
                        if (res.data.code == 200) {
                            MessageTips.success("编辑成功");
                            if(ifNext.value==true){
                                activityId.value = res.data.data.id || route.query.id;
                                activeForm.value=2
                                breadLists.value =[
                                            {
                                                name: "活动",
                                                path: {
                                                    name: "Activity",
                                                },
                                            },
                                            {
                                                name: "新增表单",
                                            },
                                        ]
                            }else{
                                router.back();
                            }
                        } else {
                            MessageTips.error(res.data.msg);
                        }
                    });
                } else {
                    console.log("error");
                    return;
                }
            });
        };


        // 国家选择
        let regionArr = [];
        const activity_address_city= ref('')
        const coutryChange = val => {
            const findObj = regionArr.find(item => item.id === val);
            userFormRef.value.country = val;
            provincesArrRef.value = findObj ? findObj.child : [];
            activity_address_city.value=findObj.name

        }
        const countryRemoteMethod = query => {
            if (query) {
                setTimeout(() => {
                    countrysRef.value = regionArr.filter((item) => {
                        return item.name.includes(query)
                    })
                }, 200)
            } else {
                countrysRef.value = []
            }
        }
        // 地区选择
        const userFormRef = ref({
            country: null,
            province: null,
            city: null,
        })
        const provinceChange = val => {
            userFormRef.value.province = val[0]
            userFormRef.value.city = val[1]
            provincesArrRef.value.forEach(item=>{
                if(item.id==val[0]){
                    activity_address_city.value+=item.name
                    item.child.forEach(ele=>{
                        if(ele.id==val[1]){
                            activity_address_city.value+=ele.name
                        }
                    })
                }
            })
        }

        // 限制文件大小
        const beforeUpload = (file) => {
            console.log(file);
            const isL1M = file.size / 1000 / 1000 <= 1;
            if (!isL1M) {
                MessageTips.error("文件上传不能大于1M");
                return false;
            }
            return true;
        };

        // 上传照片
        const fileData = ref([])

        const uploadImage = (data, target) => {
            if(target == 'file'){
                var fileItem = {
                    name:data.file.name,
                    url:""
                }
            }
            const file = data.file;
            let formData = new FormData();
            formData.append("image", file);
            formData.append("restrict", "1000");
            Ajax.POST({
                url: "/admin/upload/image",
                contentType: "multipart/form-data",
                data: formData,
            }).then((res) => {
                if (res.data.code === 200) {
                    if(target=='file'){
                        fileItem.url = res.data.data.url
                        fileData.value.push(fileItem)
                        articeFormRef.value.activity_data.push(fileItem)
                        // articeFormRef.value.activity_data.push(res.data.data.url)
                        
                    }else{
                        articeFormRef.value[target] = res.data.data.url;
                    }
                    
                } else {
                    MessageTips.error(res.data.msg);
                }
            });
        };
        //移除文件
        const handleRemove = (file,uploadFiles)=>{
            
            console.log(file, uploadFiles)
            let removeItem='';
            for (let key in file){
                let value;
                if(key!='status' && key!='uid'){
                    value = file[key]
                }
                if(value){
                    removeItem+=value
                }
            }
            articeFormRef.value.activity_data.forEach((item,index) => {
                if(removeItem==item){
                    articeFormRef.value.activity_data.splice(index, 1)
                }
            });
        }
        //选择是否收费
        const handleCharge = (data)=>{
            if(data==2){
                articeFormRef.value.is_check = "1"
            }else{
                articeFormRef.value.is_check = "2"
                articeFormRef.value.money=null
            }

        }
        //活动地点改变
        const handleLocation = (data)=>{
            if(data=='1'){
                activity_address_city.value=null
                userFormRef.value = {
                    country: null,
                    province: null,
                    city: null,
                }
                articeFormRef.value.activity_address_city= undefined
                articeFormRef.value.activity_address_city_id= undefined
            }
        }
        //获取详情 
        const detailFinished = ref(false)
        const getData =async ()=>{
            
            const ret = await Ajax.POST({
                url: "/admin/activity/detail/" + route.query.id,
            });
            if (ret.data.code === 200) {
                
                articeFormRef.value =  ret.data.data
                activity_address_city.value = ret.data.data.activity_address_city
                articeFormRef.value.is_free=ret.data.data.is_free.toString()
                articeFormRef.value.is_check=ret.data.data.is_check.toString()
                articeFormRef.value.activity_mode=ret.data.data.activity_mode.toString()
                // articeFormRef.value.status=ret.data.data.status.toString()
                articeFormRef.value.is_banner=ret.data.data.is_banner.toString()
                articeFormRef.value.activity_time = ret.data.data.activity_time.split(",")
                
                
                articeFormRef.value.activity_address_city= ret.data.data.activity_address_city_id[0]
                articeFormRef.value.activity_address_city_id=[ret.data.data.activity_address_city_id[1],ret.data.data.activity_address_city_id[2]]
                userFormRef.value = {
                    country: ret.data.data.activity_address_city_id[0],
                    province: ret.data.data.activity_address_city_id[1],
                    city: ret.data.data.activity_address_city_id[2],
                }
                const findObj = regionArr.find(item => item.id === ret.data.data.activity_address_city_id[0]);
                    provincesArrRef.value = findObj ? findObj.child : [];
                // coutryChange({id:ret.data.data.activity_address_city_id[0]})
                console.log(ret.data.data)
                // debugger
                detailFinished.value = true
            } else {
                MessageTips.error(ret.data.msg);
            }
        }
        //下一步 创建表单
        const nextStep = () =>{
            
            submitForm('formRef')
            ifNext.value=true
            breadLists.value[1].name="编辑表单"
        }
        const handlePrevious = () =>{
            ifNext.value=false
            activeForm.value=1
            breadLists.value[1].name="编辑活动"
        }
        onBeforeMount(async () => {
            const adminRegions = localStorage.getItem('adminRegions');
            if (adminRegions) {
                const regs = JSON.parse(adminRegions);
                regionArr = regs;
                countrysRef.value = regionArr.map(({ id, name }) => ({
                    id,
                    name
                }))
            } else {
                const res = await Ajax.GET({
                    url: '/admin/region'
                })
                const resData = res.data;
                if (resData.code === 200) {
                    regionArr = resData.data;
                    countrysRef.value = regionArr.map(({ id, name }) => ({
                        id,
                        name
                    }))
                }
            }
        })
        
        onMounted(() => { 
            console.log("id"+route.query.id)
            if(route.query.id){
                getData()
                breadLists.value[1].name="编辑活动"
            }else{
                detailFinished.value=true
            }
        });
        watch(articeFormRef.value,(value)=>{
            console.log(value)
            if(value.activity_time && value.register_end_time){
                if(new Date(value.register_end_time).getTime() - new Date(value.activity_time[0]).getTime()>0 || new Date(value.register_end_time).getTime() - new Date(value.activity_time[0]).getTime()==0){
                    MessageTips.error("截止日期应小于活动开始时间");
                    value.register_end_time = ''
                }
            }
        })
        return {
            breadLists,

            articeForm: articeFormRef,
            cancelSubmit,
            submitForm,
            articeFormRule,
            isLoading,
            getContentintro,
            getContentagenda,
            getContentguest,
            getContentompany,
            coutryChange,
            countryRemoteMethod,
            provinceChange,
            countrys: countrysRef,
            provinceVal: provinceValRef,
            provincesArr: provincesArrRef,
            beforeUpload,
            uploadImage,
            fileData,
            handleRemove,
            handleCharge,
            detailFinished,
            handleLocation,
            nextStep,
            activeForm,
            activityId,
            handlePrevious
        };
    },
};
</script>
  
<style lang="less" scoped>
.create-person-container {
    height: 100%;

    .write-box {
        background-color: #fff;
    }

    .user-form-box {
        width: 80%;

        // padding: 0px 180px;
        .info-img {
            width: 200px;
            height: 200px;
        }
    }

    .bottom-submit-box {
        background-color: #fff;
    }

    .form-container {
        height: 100%;
        overflow: auto;
    }
}

.dialog-search-row {
    position: relative;
    top: -24px;
    height: 52px;
    display: flex;
    align-items: center;

    span {
        position: relative;
        padding-left: 10px;

        &::before {
            content: "*";
            position: absolute;
            left: 0;
            top: 50%;
            display: inline-block;
            color: red;
            font-size: 16px;
            // line-height: 52px;
            transform: translateY(-50%);
        }
    }

    p {
        flex: 1;
        height: 46px;
        border-radius: 4px;
        border: 1px solid #bbb;
    }
}

.dialog-content-key {
    display: flex;

    .left-select-tree {
        width: 256px;

        ::v-deep(.el-menu-item) {
            height: 42px;

            &.is-active {
                position: relative;
                background-color: fadeout(@primary-color, 86%);

                &::after {
                    content: "";
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 4px;
                    height: 100%;
                    // background-color: #3894FF;
                    background-color: @primary-color;
                }
            }
        }
    }

    .right-tags-box {
        .tag-input {
            width: 100px;
            display: inline-block;
        }
    }
}

:deep(.tox-tinymce) {
    height: 200px !important;
}

.avatar-uploader {
    width: 108px;
    height: 108px;

    &.border {
        border: 1px dashed #d9d9d9;
    }

    ::v-deep(.el-upload) {
        width: 108px;
        height: 108px;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-img-box {
        width: 100%;
        height: 100%;

        .avatar {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 108px;
        height: 108px;
        line-height: 108px;
        text-align: center;
    }
}
</style>